// List of all the API's that we will be using in the project

export const API_LIST = {
    // 1. Get the personal details      
    GET_PORTFOLIO_DATA: `/portfolio`,

    // 2. Send email request
    SEND_EMAIL_REQUEST: process.env.NODE_ENV === 'production'
        ? `/.netlify/functions/contact`
        : `/portfolio/contact`
};
